<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="box">
                    <h1 class="serviceTestTitle">General Dentistry Knowledge Assessment</h1>
                    <el-tabs class='tabChild' v-model="activeIndex">
                        <el-tab-pane label="EOB Exam" name="0">
                            <span slot="label"><el-image class="status" :src="success" v-show="eobStatus"></el-image>EOB Exam</span>
                            <EOBExam @changeStatus="changeEobStatus" @changeIndex="changeIndex"></EOBExam>
                        </el-tab-pane>

                        <el-tab-pane label="Radiography Exam" name="1">
                            <span slot="label"><el-image class="status" :src="success" v-show="radiographyStatus"></el-image>Radiography Exam</span>
                            <radio-graphy-exam @changeStatus="changeGraphyStatus" @changeIndex="changeIndex"></radio-graphy-exam>
                        </el-tab-pane>
                        <el-tab-pane label="Claim Form Exam" name="2">
                            <span slot="label"><el-image class="status" :src="success" v-show="claimStatus"></el-image>Claim Form Exam</span>
                            <claimFormExam @changeStatus="changeClaimStatus" @changeIndex="changeIndex"></claimFormExam>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import claimFormExam from "./claimFormExam";
    import EOBExam from "./EOBExam";
    import RadioGraphyExam from "./RadioGraphyExam";
    import failPic from "../../assets/Relevant/fail.png"
    import successPic from "../../assets/Relevant/check_icon.png"
    import { chat2Ascii } from "../../../static/js/util.js";
    export default {
        name: "dentalBillingTest",
        components:{ApplyHeader,Side,claimFormExam,EOBExam,RadioGraphyExam},
        data(){
            return{
                loading:false,
                //开始三个测试状态不显示，等到取到测试的状态再赋值
                eobStatus:false,
                radiographyStatus:false,
                claimStatus:false,

                fail:failPic,
                success:successPic,
                activeIndex:'0',
                exitVisible:false,
                showResult:false,
                smallScreen:false,
                correctNum:0,
                totalNum:34,
                form:{
                },
                isAdmin:true,
                /**表单验证规则，所有选项都不允许为空  第10题和第26题如果一个都没有选也会提示**/
            }
        },
        computed:{
            getHeight(){
                return document.documentElement.clientHeight
            },
        },
        methods:{
            //子组件完成后通知父组件，从而改变tab页选中状态
            initTab(){
                if(!this.eobStatus){
                    this.activeIndex = '0'
                }else if(!this.radiographyStatus){
                    this.activeIndex = '1'
                }else if(!this.claimStatus){
                    this.activeIndex = '2'
                }else{
                    this.activeIndex = '0'
                }
            },
            changeEobStatus(){
                this.eobStatus = true
                this.initTab()
            },
            changeGraphyStatus(){
                this.radiographyStatus = true
                this.initTab()
            },
            changeClaimStatus(){
                this.claimStatus = true
                this.initTab()
            },
            changeIndex(index){
                // console.log('改变激活的tab',index)
                this.activeIndex = index
            }
        },
        created() {
            if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                var email = this.$route.query.email
                // console.log('进入dentalBilling',chat2Ascii(email))
                return
            }
            // console.log('dental billing test')
            //把测试得状态全部置空，但是要保证在三个tab激活之前
            this.$store.commit('saveFinishModule',{})
        },
        mounted() {
            var clientW = document.documentElement.clientWidth
            if(clientW<1220){
                this.smallScreen=true
            }
            //when no serviceid info, go back to service list
            var storeService = this.$store.state.serviceInfo
            // console.log('get serviceId:' + storeService.serviceId)
            if(this.$route&&this.$route.query.model=='review'&&this.$route.query.verify){
                var email = this.$route.query.email
                var verify = this.$route.query.verify
                var verifyCode = chat2Ascii(email)
                if(verifyCode!=verify){
                    this.isAdmin=false
                    this.$router.push('/login')
                }
                return
            }
            if(storeService.serviceId == undefined){
                this.$router.push({path:'/service'})
                return;
            }
            this.initTab()
        },
        watch:{
            '$route'(to,from){
                // console.log(from.path)
                if(to.path==='/dentalBillingTest'){
                    // console.log('container')
                }
            },
        }
    }
</script>

<style scoped>
    .tabChild{
        padding: 25px 10px;
    }
    .tabChild>>>.el-tabs__item{
        width: 200px;
        text-align: center;
    }
    .status{
        width: 20px;
        position: absolute;
        left: 10px;
        top:10px
    }
</style>